import { createLoadingSelector, getPaymentProviders } from "../../../selectors";
import React, { Component } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  getCurrentPaymentProviderId,
  findProviderIds,
  getPaymentProviderById,
  patchPaymentProvider,
  testPaymentProvider,
  clearCurrentPaymentProviderId,
  clearPaymentProviders,
  clearProviderIds,
} from "../../../actions/paymentProvider.actions";
import { getErrorMessage } from "../../../utils/helpers";
import { showModal } from "../../../actions/modal.actions";
import SingleProviderAndConfigurationsComponent from "../MappingConfigurations/SingleProviderAndConfigurationsComponent";

class PaymentProviderSettings extends Component {
  uiPaymentProviders = {
    AUTHORIZENET: {
      label: "Authorize.Net",
      icon: "/images/AuthorizeNet.jpeg",
      order: 0,
    },
    IPPAY: {
      label: "IPPAY",
      icon: "/images/IPpay.png",
      order: 1,
    },
    PAYMENTUS: {
      label: "Paymentus",
      icon: "/images/Paymentus.svg",
      order: 2,
    },
    VERIFONE: {
      label: "Verifone",
      icon: "/images/Verifone.svg",
      order: 3,
    },
    STRIPE: {
      label: "Stripe",
      icon: "/images/Stripe.svg",
      order: 4,
    }
  };

  componentDidMount() {
    document.title = "Payment Provider - camvio.cloud";
    this.props.changeNavBarType("default", "Payment Provider");

    this.props.getCurrentPaymentProviderId().then((resp) => {
      this.props.getPaymentProviderById(resp.data.id);
    });

    this.props.findProviderIds();
  }

  componentWillUnmount() {
    this.props.clearCurrentPaymentProviderId();
    this.props.clearPaymentProviders();
    this.props.clearProviderIds();
  }

  handleSubmit = (values, actions) => {
    actions.setSubmitting(false);
  };

  onCurrentProviderChangeHandler = (name, value, formProps) => {
    formProps.setFieldValue(name, value);
    if (value) {
      this.props.getPaymentProviderById(value).then((resp) => {
        formProps.setFieldValue("providerConfiguration", resp.data);
      });
    } else {
      formProps.setFieldValue("providerConfiguration", null);
    }
  };

  saveProviderConfiguration = ({ setSubmitting, values }) => {
    setSubmitting(true);

    this.props
      .patchPaymentProvider(values.providerId, values.providerConfiguration)
      .then((response) => {
        if (response.success === false) {
          console.error(response);
          toastr.error(getErrorMessage(response).message, { position: "top-center" });
        } else {
          const message =
            (response.data && response.data.message) || response.data || "Payment provider updated successfully";

          toastr.success(message, { timeOut: 3000, position: "top-center" });

          this.props
            .getPaymentProviderById(values.providerId)
            .then((resp) => setSubmitting(false))
            .catch((error) => {
              console.error(error);
              setSubmitting(false);
            });
        }
      })
      .catch((e) => {
        console.error(e);
        toastr.error("Something went wrong", { timeOut: 5000, position: "top-center" });

        setSubmitting(false);
      });
  };

  onConfigurationSaveBtnClick = (updatedProps, formProps) => {
    this.props.showModal("CONFIRM_CHANGES_AND_ACTION_MODAL", {
      title: "Save Configuration",
      text: "Are you sure you want to make these changes?",
      changes: updatedProps,
      action: () => this.saveProviderConfiguration(formProps),
    });
  };

  render() {
    const { currentProviderId, providers, providerIds, isLoading } = this.props;

    const providerIdOptions = [{ label: "NONE", value: null }];

    if (providerIds) {
      providerIds.forEach((pid) => providerIdOptions.push({ label: pid, value: pid }));
    }

    return (
      <div className="cmv-container cmv-container-dashboard cmv-container-client-selected">
        <SingleProviderAndConfigurationsComponent
          providerUiOptions={this.uiPaymentProviders}
          title="Payment Provider"
          getCurrentProviderId={this.props.getCurrentPaymentProviderId}
          getProviderConfigurationById={this.props.getPaymentProviderById}
          getAllProviderIds={this.props.findProviderIds}
          clearProviderById={this.props.clearCurrentPaymentProviderId}
          clearAllProviders={this.props.clearPaymentProviders}
          clearAllProviderIds={this.props.clearProviderIds}
          currentProviderId={currentProviderId}
          allProviderIds={providerIds}
          providers={providers}
          saveProviderConfiguration={this.props.patchPaymentProvider}
          testProviderConfiguration={this.props.testPaymentProvider}
          isLoading={isLoading}
          showModal={this.props.showModal}
        />
      </div>
    );
  }
}

const selectCurrentProviderIdLoading = createLoadingSelector(["PAYMENT_PROVIDER_FIND_CURRENT_PROVIDER_ID"]);
const selectLoadingProviderConfiguration = createLoadingSelector(["PAYMENT_PROVIDER_FIND_PROVIDER"]);
const selectLoadingProviderIds = createLoadingSelector(["PAYMENT_PROVIDER_FIND_ALL_IDS"]);

const mapStateToProps = (state) => {
  const currentProviderId = getPaymentProviders(state).currentProviderId,
    providers = getPaymentProviders(state).providers,
    providerIds = getPaymentProviders(state).providerIds,
    isLoadingCurrentProviderId = selectCurrentProviderIdLoading(state),
    isLoadingProviderConfiguration = selectLoadingProviderConfiguration(state),
    isLoadingProviderIds = selectLoadingProviderIds(state);

  const isLoading = isLoadingCurrentProviderId || isLoadingProviderConfiguration || isLoadingProviderIds;

  return {
    currentProviderId,
    providers,
    providerIds,
    isLoading,
  };
};

const mapDispatchToProps = {
  showModal,
  getCurrentPaymentProviderId,
  getPaymentProviderById,
  findProviderIds,
  patchPaymentProvider,
  testPaymentProvider,
  clearCurrentPaymentProviderId,
  clearPaymentProviders,
  clearProviderIds,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentProviderSettings);
